export class EncounterService {
  url_base = 'https://novasector.net/v1/'

  constructor() {
    if(process.env.NODE_ENV === 'development') {
      this.url_base = '/v1/'
    }
  }


  async generate(tgrp, ter_act) {
    const params = new URLSearchParams({
      tgrp,
      ter_act
    }).toString()
    const url = this.url_base + 'encounter/gen/?' + params
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        "Content-type": "application/json; charset=UTF-8"
      }
    })
    const enc = await res.json()
    // console.log('[encounter service] <generate> enc:', enc)
    return enc
  }

}


